export function filterItems(items, filters, search_query){
  let filter_date_from = "";
  let filter_date_to = "";
  let checkbox_filters = {};


  filters.forEach((filter) => {


    if (filter.type === "checkboxes"){
      filter.elements.forEach(element => {
        if (element.selected){
          if (typeof checkbox_filters[element.parent] != "undefined"){
            checkbox_filters[element.parent].push(element.id);
          } else {
            checkbox_filters[element.parent] = [element.id];
          }

        }
      });
    }

  })

  let filtered_items = items.filter(item => {

    let visible = true;

    if (search_query.length >= 2){
      let in_search = item.search_data.toLowerCase().indexOf(search_query.toLowerCase()) > -1 || !search_query.length
      if (!in_search){
        return false;
      }
    }


    if (Object.keys(checkbox_filters).length){
      for (var checkbox_filter in checkbox_filters) {
        let f = checkbox_filters[checkbox_filter];
        if (f.includes(99999999)){
          return true;
        }

        if (typeof item[checkbox_filter] !== "undefined"){

          return item[checkbox_filter].some(r=> f.includes(r))

        } else {
          return false;
        }
      }
    }







    return true;



  });

  return filtered_items;
}
